import * as Enumerable from 'linq';
import { AccountingSystemMapping, Entity, InvoiceContact, QuickbookTaxInclusiveOption, TaxInclusiveOption, TaxRateMapping } from '../entities';

export class AccountingSystemMappingUtility {

    public static getInvoiceGL(mapping: AccountingSystemMapping): Entity {
        if (!mapping || !mapping.invoiceGL) return this.getNotMapped();
        return mapping.invoiceGL;
    }

    public static getItemRef(mapping: AccountingSystemMapping): Entity {
        if (!mapping || !mapping.item) return this.getNotMapped();
        return mapping.item;
    }

    public static getBillGL(mapping: AccountingSystemMapping): Entity {
        if (!mapping || !mapping.billGL) return this.getNotMapped();
        return mapping.billGL;
    }

    public static getPurchaseGL(mapping: AccountingSystemMapping): Entity {
        if (!mapping || !mapping.purchaseGL)
            return this.getNotMapped();

        return mapping.purchaseGL;
    }

    public static getQuickbookTaxInclusiveOption(option: TaxInclusiveOption): QuickbookTaxInclusiveOption {

        switch (option) {
            case TaxInclusiveOption.Exclusive:
                return QuickbookTaxInclusiveOption.Exclusive;
            case TaxInclusiveOption.Inclusive:
                return QuickbookTaxInclusiveOption.Inclusive;
            case TaxInclusiveOption.NoTax:
                return QuickbookTaxInclusiveOption.NoTax;

        }

    }

    public static getTaxType(mapping: AccountingSystemMapping, taxRateId: string): string {
        if (!mapping || !taxRateId) return null;

        const tr = Enumerable
            .from(mapping.incomeTaxRates)
            .concat(mapping.expenseTaxRates)
            .where(x => x.taxRateId === taxRateId)
            .select(x => x.integrationId ? x.integrationId._id : null)
            .firstOrDefault();

        return tr;
    }

    public static getTaxTypeMapping(mapping: AccountingSystemMapping, taxRateId: string): TaxRateMapping {
        if (!mapping || !taxRateId) return null;

        const tr = Enumerable
            .from(mapping.incomeTaxRates)
            .concat(mapping.expenseTaxRates)
            .where(x => x.taxRateId === taxRateId)
            .firstOrDefault();

        return tr;
    }

    public static getCustomer(mapping: AccountingSystemMapping, customerId: string): string {
        if (!mapping) return null;

        const customer = Enumerable.from(mapping.customers).firstOrDefault(x => x.customerId === customerId);

        return customer
            ? customer?.contactId
            : null;

    }

    public static getSubcontractor(mapping: AccountingSystemMapping, technicianId: string): string {
        if (!mapping) return null;

        const technician = Enumerable.from(mapping.technicians).firstOrDefault(x => x.technicianId === technicianId);

        return technician
            ? technician?.contactId
            : null;

    }

    public static getSupplier(mapping: AccountingSystemMapping, supplierId: string): string {
        if (!mapping) return null;

        const supplier = Enumerable.from(mapping.suppliers).firstOrDefault(x => x.supplierId === supplierId);

        return supplier
            ? supplier?.contactId
            : null;

    }

    public static getContact(mapping: AccountingSystemMapping, contact: InvoiceContact, isBill: boolean) {
        let contactId: string;
        if (isBill) {
            contactId = contact.type === 'Supplier'
                ? AccountingSystemMappingUtility.getSupplier(mapping, contact._id)
                : AccountingSystemMappingUtility.getSubcontractor(mapping, contact._id)
        } else {
            contactId = AccountingSystemMappingUtility.getCustomer(mapping, contact._id);
        }
        return contactId
    }

    private static getNotMapped(): Entity {
        return {
            _id: null,
            name: 'Not Mapped'
        } as Entity;
    }

}
